import './App.css';
import { WordBlitz } from "./components/WordBlitz"

function App() {
    return (
    <div className="App">
        <WordBlitz />
    </div>
    );
}
export default App;
